import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import ManageInstrumentComponentVM from './ManageInstrumentComponentVM';
import moment from 'moment';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageInstrumentComponentProps {
    viewModel: ManageInstrumentComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageInstrumentComponent extends React.Component<IManageInstrumentComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <div>
                {<Neo.Card title={`${viewModel.managedInstrument.instrumentID === 0 ? TextConstants.Titles.AddInstrument : TextConstants.Titles.EditInstrument}`}>
                    <Neo.Form model={viewModel.managedInstrument}
                        validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                        onSubmit={() => this.props.onSave()}
                        onInvalid={() => this.onFormInvalid}>
                        <div className="row">
                            <div className="col-lg-5">
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.InstrumentName}
                                    bind={viewModel.managedInstrument.meta.description}
                                    placeholder={TextConstants.PlaceHolder.InstrumentName}/>
                            </div>
                            <div className="col-lg-3">
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.TickerSymbol}
                                    bind={viewModel.managedInstrument.meta.ticker}
                                    placeholder={TextConstants.PlaceHolder.Ticker}/>
                            </div>
                            <div className="col-lg-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.Isin}
                                    bind={viewModel.managedInstrument.meta.isin}
                                    placeholder={TextConstants.PlaceHolder.ISIN}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <Neo.FormGroup bindContext={viewModel.managedInstrument.meta.instrumentType}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.instrumentTypeApiClient.getInstrumentSubTypesByCriteria}
                                        bind={viewModel.managedInstrument.meta.instrumentSubTypeID}
                                        bindDisplay={viewModel.managedInstrument.meta.instrumentType}
                                        displayMember={"instrumentSubTypeName"} 
                                        items={viewModel.instrumentTypeApiClient.getInstrumentSubTypesByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.instrumentSubTypeName.localeCompare(y.instrumentSubTypeName)))}    
                                    />
                                </Neo.FormGroup>
                            </div>
                            <div className="col-lg-3">
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.MaturityDate}
                                    bind={viewModel.managedInstrument.meta.maturityDate}
                                    dateProps={{ minDate: moment().subtract(3, 'months').toDate() }} />
                            </div>
                            <div className="col pt-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.Deleted}
                                    bind={viewModel.managedInstrument.meta.isDeletedInd} />
                            </div>
                            <div className="col pt-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.DualListed}
                                    bind={viewModel.managedInstrument.meta.isDualListed} />
                            </div>
                            <div className="col pt-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.REIT}
                                    bind={viewModel.managedInstrument.meta.isREIT} />
                            </div>
                            <div className="col pt-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ListedInstrument}
                                    bind={viewModel.managedInstrument.meta.isListedInstrumentInd} />
                            </div>
                        </div>
                        <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                    </Neo.Form>
                </Neo.Card>}
            </div>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidInstrument);
        }
    }
}